var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpineDiscomfort(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_3",
    "data-name": "Layer 3",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.491,11.008A11.057,11.057,0,0,0,39,7V1H37V8a1,1,0,0,0,1,1h1a9.043,9.043,0,0,1,7.2,3.6,1,1,0,0,0,.8.4A14.015,14.015,0,0,1,61,27V63h2V27A16.019,16.019,0,0,0,47.491,11.008Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.937,32.352l-1.874-.7-3,8A1.009,1.009,0,0,0,49,40v2.764a8.525,8.525,0,0,1-.9,3.789A10.536,10.536,0,0,0,47,51.236V63h2V51.236a8.525,8.525,0,0,1,.9-3.789,10.5,10.5,0,0,0,.9-2.737,27.5,27.5,0,0,1,1.2,8V63h2V52.708A29.561,29.561,0,0,0,51.083,39.96Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26,9a1,1,0,0,0,1-1V1H25V7a11.057,11.057,0,0,0-8.491,4.008A16.019,16.019,0,0,0,1,27V63H3V27A14.015,14.015,0,0,1,17,13a1,1,0,0,0,.8-.4A9.043,9.043,0,0,1,25,9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15,42.764V40a1.009,1.009,0,0,0-.063-.352l-3-8-1.874.7,2.854,7.608A29.561,29.561,0,0,0,10,52.708V63h2V52.708a27.5,27.5,0,0,1,1.2-8,10.5,10.5,0,0,0,.9,2.737A8.525,8.525,0,0,1,15,51.236V63h2V51.236A10.536,10.536,0,0,0,15.9,46.553,8.525,8.525,0,0,1,15,42.764Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36,58a1,1,0,0,0-1-1H29a1,1,0,0,0-1,1v1H26v2h2v1a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V61h2V59H36Zm-2,3H30V59h4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36,50a1,1,0,0,0-1-1H29a1,1,0,0,0-1,1v1H26v2h2v1a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V53h2V51H36Zm-2,3H30V51h4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36,42a1,1,0,0,0-1-1H29a1,1,0,0,0-1,1v1H26v2h2v1a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V45h2V43H36Zm-2,3H30V43h4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37,35H35.28l-.31-1.242A1,1,0,0,0,34,33H30a1,1,0,0,0-.97.758L28.72,35H27v2h1.22l-.19.758A1,1,0,0,0,29,39h6a1,1,0,0,0,.97-1.242L35.78,37H37Zm-6.719,2,.5-2h2.438l.5,2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37,27H35.28l-.31-1.242A1,1,0,0,0,34,25H30a1,1,0,0,0-.97.758L28.72,27H27v2h1.22l-.19.758A1,1,0,0,0,29,31h6a1,1,0,0,0,.97-1.242L35.78,29H37Zm-6.719,2,.5-2h2.438l.5,2Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37,19H35.28l-.31-1.242A1,1,0,0,0,34,17H30a1,1,0,0,0-.97.758L28.72,19H27v2h1.22l-.19.758A1,1,0,0,0,29,23h6a1,1,0,0,0,.97-1.242L35.78,21H37Zm-6.719,2,.5-2h2.438l.5,2Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11v2h1.22l-.19.758A1,1,0,0,0,29,15h6a1,1,0,0,0,.97-1.242L35.78,13H37V11H35.28l-.31-1.242A1,1,0,0,0,34,9H30a1,1,0,0,0-.97.758L28.72,11Zm3.781,0h2.438l.5,2H30.281Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.172,
    y: 22,
    width: 5.657,
    height: 2,
    transform: "translate(-4.548 35.021) rotate(-45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 27,
    width: 5,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 30.172,
    width: 2,
    height: 5.657,
    transform: "translate(-11.619 37.95) rotate(-45)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 20.172,
    width: 2,
    height: 5.657,
    transform: "translate(-9.234 23.707) rotate(-45)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 27,
    width: 5,
    height: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.172,
    y: 32,
    width: 5.657,
    height: 2,
    transform: "translate(-16.305 26.636) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpineDiscomfort);
export default __webpack_public_path__ + "static/media/spine-discomfort.5762dc10b3b6172c3bf5d586d8950bd8.svg";
export { ForwardRef as ReactComponent };